





















import { Data, Member } from "@/types";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class OperatersBar extends Vue {
  @Prop()
  private data!: Data;

  isWarning(member: Member) {
    if (member.warning !== undefined) {
      return true;
    }
  }
}
